import { z } from 'zod';
/** Asset IDs are the asset type's prefix plus a zero-padded sequence, 12 characters in all. */
export const ASSET_CODE_LENGTH = 12;
export const ASSET_TYPE_PREFIX_MAX_LENGTH = 4;
const DECIMAL_BASE = 10;
const PREFIX = new RegExp(`^[A-Z]{1,${String(ASSET_TYPE_PREFIX_MAX_LENGTH)}}$`);
const CODE = new RegExp(`^[A-Z]{1,${String(ASSET_TYPE_PREFIX_MAX_LENGTH)}}[0-9]+$`);
/** 1–4 uppercase letters (typed in any case). */
export const zAssetTypePrefix = z.string().trim().toUpperCase().regex(PREFIX);
/** An asset ID such as `PC0000000001` (typed or scanned in any case). */
export const zAssetCode = z.string().trim().toUpperCase().length(ASSET_CODE_LENGTH).regex(CODE);
/** Digits left for the sequence after the prefix (11 down to 8). */
const sequenceDigits = (prefix) => ASSET_CODE_LENGTH - prefix.length;
/** The highest sequence an asset type with this prefix can number. */
export function maxSequence(prefix) {
    return DECIMAL_BASE ** sequenceDigits(prefix) - 1;
}
/** `formatAssetCode('PC', 1)` → `PC0000000001`. */
export function formatAssetCode(prefix, sequence) {
    if (!PREFIX.test(prefix) || !Number.isSafeInteger(sequence) || sequence < 1) {
        throw new RangeError(`invalid prefix or sequence: ${prefix} ${String(sequence)}`);
    }
    if (sequence > maxSequence(prefix)) {
        throw new RangeError(`sequence ${String(sequence)} does not fit after ${prefix}`);
    }
    return `${prefix}${String(sequence).padStart(sequenceDigits(prefix), '0')}`;
}
//# sourceMappingURL=asset-code.js.map